<template lang="pug">
.pb-4
  v-layout(column)
    label: b Heb je elders lopende leningen?*
    v-select(
      v-model='hasOtherLoans',
      :items='yesNoItems',
      required,
      solo
      )

    text-field(
      v-if='hasOtherLoans',
      v-model.number='data.otherLoansAmount',
      label='Aantal lopende leningen',
      required,
      type='number',
      min='1'
      )

  template(v-if='hasOtherLoans')
    loan(
      v-for='(loan, i) in data.loans',
      :key='"loan" + i',
      :loan='loan',
      @setLoan='setLoan',
      :loanIndex='i',
      :ref='"loan" + i',
      @setValid='setValid'
      )
</template>

<script>
// import { required } from 'vuelidate/lib/validators'
import required from 'vuelidate/src/validators/required'
import { yesNoDropdownItems } from './helpers/template'
import Loan from './_components/Loan'

const DEFAULT_LOAN = {
  consolidateLoan: false
}

export default {
  props: {
    value: Object
  },

  components: {
    Loan
  },

  data () {
    return {
      data: this.value,

      yesNoItems: yesNoDropdownItems,

      loanValidations: [],
      hasOtherLoans: false // Workaround because data.otherLoans isnt reactive for some reason
      // TODO test that hasOtherLoans=true opens the input field below
    }
  },

  methods: {
    emit () {
      this.$emit('input', this.data)
    },

    setValid ({ loanIndex, valid }) {
      this.$set(this.loanValidations, loanIndex, valid)
    },

    setLoan ({ loanIndex, loan }) {
      // this.$set(this.data.loans, loanIndex, loan) // Actually because of :loan='loan' it is already reference bound so this is superfluous but keep it here to be sure
    },

    initLoans () {
      // TODO this doesnt work, for some reason the emit is triggered too early and the parent gets the previous loans[]
      // if (!this.data.loans) this.data.loans = []

      // for (let i = 0; i < this.data.otherLoansAmount; i++) {
      //   if (!this.data.loans[i]) this.data.loans[i] = Object.assign({}, DEFAULT_LOAN)
      //   if (this.loanValidations[i] === undefined) this.loanValidations[i] = null
      // }

      // if (this.data.loans.length >= this.data.otherLoansAmount) {
      //   this.data.loans.splice(this.data.otherLoansAmount, this.data.loans.length - this.data.otherLoansAmount)
      //   this.loanValidations.splice(this.data.otherLoansAmount, this.loanValidations.length - this.data.otherLoansAmount)
      // }

      // This works but its very slow cause its triggered 4 times per loan
      let loans = []
      let otherLoansAmount = this.data.otherLoansAmount

      for (let i = 0; i < otherLoansAmount; i++) {
        if (!loans[i]) loans[i] = Object.assign({}, DEFAULT_LOAN)
        if (this.loanValidations[i] === undefined) this.loanValidations[i] = null
      }

      if (loans.length >= otherLoansAmount) {
        loans.splice(otherLoansAmount, loans.length - otherLoansAmount)
        this.loanValidations.splice(otherLoansAmount, this.loanValidations.length - otherLoansAmount)
      }

      this.$set(this.data, 'loans', loans)
      this.$set(this.data, 'otherLoansAmount', otherLoansAmount)
    }
  },

  validations: {
    data: {
      otherLoans: {
        required,
        allLoansValid: function (v) {
          return this.loanValidations.every(x => x)
        }
      }
    }
  },

  created () {
    this.initLoans()

    this.emit()
  },

  watch: {
    'hasOtherLoans' (v) {
      if (!v) {
        this.data.otherLoansAmount = 0
      } else if (this.data.otherLoansAmount === 0) {
        this.data.otherLoansAmount = 1
      }

      this.data.otherLoans = v
    },

    'data.otherLoansAmount' (v) {
      this.initLoans()
    },

    '$v.$invalid': {
      handler: function (invalid) {
        this.$emit('setValid', {
          modelName: 'loanModel',
          valid: !invalid
        })
      },
      deep: true,
      immediate: true
    },

    value (v) {
      this.data = v
    },

    data: {
      handler: function (v) {
        this.emit()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
